import React, { useEffect, useState,useContext } from 'react';
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  IconButton,
  Button,
  Tooltip,
  CircularProgress,
  Chip,Paper
} from '@mui/material';
import axios from 'axios';
import {
  Favorite,
  Share,
  ThumbUpAltOutlined,
  ThumbUpAlt,
  Call,
  Chat,
  LocationOn,
  ChevronLeft,
  ChevronRight
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import CustomSearchBar from './../Lease Module/CustomSearch';
import BottomNavbar from './CustomNav';
import { AuthContext } from './../../AuthContext/AuthContext';
import { BASE_URL } from '../../Api/ApiUrls';


const BuySaves = () => {
  const [saved, setSaved] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedType, setSelectedType] = useState(null);
  const [likedCards, setLikedCards] = useState({});
  const [currentImageIndex, setCurrentImageIndex] = useState({});
  
 const [isSubscribed, setIsSubscribed] = useState(false);
  const [showLimitModal, setShowLimitModal] = useState(false);
  const [userActivities, setUserActivities] = useState([]);
  const [showSubscribeModal, setShowSubscribeModal] = useState(false);
  const [featureRequested, setFeatureRequested] = useState('');
  const [locationLoading, setLocationLoading] = useState({});
  const [userPlan, setUserPlan] = useState(null);

  const navigate = useNavigate();
 const { userId, logout } = useContext(AuthContext);
  const [loading, setLoading] = useState(true); 

    const [priceFilter, setPriceFilter] = useState(null);
            
            // Add this handler function
            const handlePriceFilterChange = (range) => {
              setPriceFilter(range);
            };
const rentalTypes = [
    "PLOT/LAND", "COMMERCIAL LAND/PLOT", "RENT WITH DUPLEX BUILDING", "DUPLEX HOUSE",
    "RENTAL BUILDING", "PG-OFFICES", "FLAT", "VILLA",
    "COMMERCIAL BUILDING", "APARTMENT", "JV/JD"
  ];
useEffect(() => {
    const fetchData = async () => {
      try {
        // Step 1: Fetch user's saved properties (cart items)
        const cartResponse = await axios.get(`${BASE_URL}/get-user-cart/${userId}/`);
        console.log("cartResponse:",cartResponse);
        const cartItems = cartResponse.data;

        // Step 2: Fetch all properties to get full details
        const propertiesResponse = await axios.get(`${BASE_URL}/property/`);
        
        // Step 3: Get categories for property type mapping
        const categoriesResponse = await axios.get(`${BASE_URL}/property-category/`);
        
        // Step 4: Filter and map saved properties
        const savedProperties = cartItems
          .map(cartItem => {
            // Find the property and ensure it's a "sell" type
            const property = propertiesResponse.data.find(
              p => p.property_id === cartItem.property_id && 
                   p.type && 
                   p.type.toLowerCase().includes("sell")
            );
            if (!property) return null;

            const parseCoord = (coord) => {
              if (!coord) return null;
              const cleaned = coord.replace(/"/g, '').replace(':', '.');
              return parseFloat(cleaned);
            };

            const matchedCategory = categoriesResponse.data.find(
              cat => cat.category_id == property.category_id
            );
            
            const categoryName = matchedCategory ? matchedCategory.category : 'Property';

            // Get all images or default image
            const images = property.property_images?.length > 0 
              ? property.property_images.map(img => `${BASE_URL}${img.image}`)
              : ['/default-property-image.jpg'];

            return {
              id: property.property_id,
              cart_id: cartItem.cart_id, // Keep cart_id for removal
              created_at: cartItem.created_at, // Attach created_at for sorting
              title: categoryName,
              location: property.location || 'Not specified',
              price: `₹${property.price?.toLocaleString()}`,
              date: property.created_at?.split('T')[0],
              facing: property.facing?.replace(/"/g, '') || 'N/A',
              area: property.site_area ? `${property.site_area} sq ft` : 'N/A',
              dimensions: property.roadwidth ? `${property.roadwidth} ft road` : 'N/A',
              posted_by: property.list?.replace(/"/g, '') || 'Agent',
              lat: parseCoord(property.lat),
              long: parseCoord(property.long),
              length: property.length,
              width: property.width,
              mobile_no: property.mobile_no,
              property_name: property.property_name,
              images: images,
              owner:property.user_id,
              propertyData: property
            };
          })
          .filter(Boolean)
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)); // Sort by latest saved // Remove any null entries

        setSaved(savedProperties);
        
        // Initialize current image index for each property
        const initialIndexes = {};
        savedProperties.forEach(property => {
          initialIndexes[property.id] = 0;
        });
        setCurrentImageIndex(initialIndexes);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    if (userId) {
      fetchData();
    }
  }, [userId]);

   // Filter properties based on search query and selected type
  const filteredProperties = saved.filter((property) => {
  const matchesSearch = 
    property.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    property.location.toLowerCase().includes(searchQuery.toLowerCase());
  
  const matchesType = selectedType 
    ? property.title.toLowerCase().includes(selectedType.toLowerCase())
    : true;
  
const matchesPrice = priceFilter
  ? property.propertyData.price >= priceFilter.min &&
    property.propertyData.price <= priceFilter.max
  : true;

  
  return matchesSearch && matchesType && matchesPrice;
});

  const handleRemove = async (propertyId) => {
    try {
      // Find the cart item to get cart_id
      const cartItem = saved.find(item => item.id === propertyId);
      if (!cartItem) return;

      await axios.delete(`${BASE_URL}/user-cart/${cartItem.cart_id}/`);
      
      // Update local state
      const updated = saved.filter((item) => item.id !== propertyId);
      setSaved(updated);
    } catch (error) {
      console.error('Error removing property:', error);
    }
  };
  const toggleLike = (id) => {
    setLikedCards((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleNextImage = (propertyId, e) => {
    e.stopPropagation();
    setCurrentImageIndex(prev => {
      const currentIndex = prev[propertyId] || 0;
      const property = saved.find(p => p.id == propertyId);
      const nextIndex = (currentIndex + 1) % (property.images?.length || 1);
      return {
        ...prev,
        [propertyId]: nextIndex
      };
    });
  };

  const handlePrevImage = (propertyId, e) => {
    e.stopPropagation();
    setCurrentImageIndex(prev => {
      const currentIndex = prev[propertyId] || 0;
      const property = saved.find(p => p.id == propertyId);
      const prevIndex = (currentIndex - 1 + (property.images?.length || 1)) % (property.images?.length || 1);
      return {
        ...prev,
        [propertyId]: prevIndex
      };
    });
  };

// useEffect(() => {
//   const checkSubscription = async () => {
//     try {
//       console.log('Checking subscription for user:', userId);
//       const response = await axios.get(`${BASE_URL}/Get-all-plan/${userId}/`);
//       const userSubscription = response.data;

//       console.log('Found subscription:', userSubscription);
//   const matchedSub = userSubscription.find(
//     (sub) => sub.status === true && sub.user_type === "Buyer"
//   );

//   if (matchedSub) {

//       // Check both status and user_type
//     //  if (userSubscription && userSubscription.status && userSubscription.user_type === "Buyer") {
//         console.log('User is subscribed and is a Buyer');
//         setIsSubscribed(true);
//       } else {
//         console.log('User is NOT subscribed or not a Buyer');
//         setIsSubscribed(false);
//       }
//     } catch (error) {
//       console.error('Error checking subscription:', error);
//       setIsSubscribed(false);
//       setUserPlan(null);
//     }
//   };

//   if (userId) {
//     checkSubscription();
//   } else {
//     console.log('No user ID, defaulting to non-subscribed state');
//     setIsSubscribed(false);
//     setUserPlan(null);
//   }
// }, [userId]);

// Fetch and filter user activities

useEffect(() => {
  const checkSubscription = async () => {
    try {
      console.log('Checking subscription for user:', userId);
      const response = await axios.get(`${BASE_URL}/Get-user-plan/${userId}/`);
      const userSubscriptions = response.data;

      console.log('Found subscriptions:', userSubscriptions);
      
      // Check if any subscription matches the Buyer type
      const hasBuyerSubscription = Array.isArray(userSubscriptions) && 
        userSubscriptions.some(sub => sub.user_type === "Buyer");

      if (hasBuyerSubscription) {
        console.log('User has a Buyer subscription');
        setIsSubscribed(true);
      } else {
        console.log('User does NOT have a Buyer subscription');
        setIsSubscribed(false);
        setUserPlan(null);
      }
    } catch (error) {
      console.error('Error checking subscription:', error);
      setIsSubscribed(false);
      setUserPlan(null);
    }
  };

  if (userId) {
    checkSubscription();
  } else {
    console.log('No user ID, defaulting to non-subscribed state');
    setIsSubscribed(false);
    setUserPlan(null);
  }
}, [userId]);

useEffect(() => {
  const fetchUserActivities = async () => {
    if (!userId) {
      console.log('No userId - skipping activity fetch');
      return;
    }
    
    try {
      console.log(`Fetching activities for user ${userId}`);
      const response = await fetch(`${BASE_URL}/activities/`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const allActivities = await response.json();
      console.log('All activities from API:', allActivities);
      
      // Enhanced filtering with type checking
      const filteredActivities = allActivities.filter(activity => {
        // Check if activity exists and has user_id property
        if (!activity || activity.user_id === undefined) {
          console.warn('Invalid activity object:', activity);
          return false;
        }
        
        // Compare user_id (convert both to string for safety)
        return String(activity.user_id) === String(userId);
      });
      
      console.log('Filtered user activities:', filteredActivities);
      setUserActivities(filteredActivities);
      
    } catch (error) {
      console.error('Error fetching activities:', error);
      setUserActivities([]);
    }
  };

  fetchUserActivities();
}, [userId]);

// Enhanced property limit check with dynamic limits
const checkPropertyLimit = (currentPropertyId) => {
  if (!isSubscribed) {
    console.log('Non-subscriber - access denied');
    setFeatureRequested("Property Access");
    setShowSubscribeModal(true);
    return false;
  }

  // If unlimited access is granted
  if (userPlan?.no_of_properties_unlimited) {
    console.log('User has unlimited property access');
    return true;
  }

  const uniqueProperties = new Set(userActivities.map(a => a.property_id));
  const isExistingProperty = uniqueProperties.has(currentPropertyId);
  
  console.log(`User has accessed ${uniqueProperties.size} unique properties`);
  console.log(`Is current property already accessed? ${isExistingProperty}`);

  // Get the dynamic limit from user plan, default to 10 if not available
  const propertyLimit = userPlan?.no_of_properties || 10;
  
  if (uniqueProperties.size >= propertyLimit && !isExistingProperty) {
    console.log(`Property limit (${propertyLimit}) exceeded - showing limit modal`);
    setShowLimitModal(true);
    return false;
  }
  
  return true;
};

// Enhanced logActivity with proper property handling
const logActivity = async (propertyId, activityType) => {
  // Find the property in the saved state
  const property = saved.find(p => p.id === propertyId);
  
  if (!property) {
    console.error('Property not found for logging activity');
    return false;
  }

  const postData = {
    user_id: userId,
    property_id: propertyId,
    activity_type: activityType,
    property_by: property.owner 
  };

  console.log('Posting activity data:', postData);

  try {
    const response = await fetch(`${BASE_URL}/activities/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(postData)
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Failed to log activity:', errorData);
      throw new Error(errorData.message || 'Failed to log activity');
    }
    
    const newActivity = await response.json();
    console.log('Activity logged successfully:', newActivity);
    setUserActivities(prev => [...prev, newActivity]);
    return true;
  } catch (err) {
    console.error("Error logging activity:", err);
    return false;
  }
};

 // Updated handleAction to check limits before executing
const handleAction = async (e, propertyId, actionName, actionCallback, activityType) => {
  e.stopPropagation();
  
  if (!isSubscribed) {
    setFeatureRequested(actionName);
    setShowSubscribeModal(true);
    return;
  }

  // Check property limit BEFORE executing action
  if (activityType && !checkPropertyLimit(propertyId)) {
    return; // Stop if limit exceeded
  }

  try {
    // Execute the action
    await actionCallback();
    
    // Log activity if specified
    if (activityType) {
      await logActivity(propertyId, activityType);
    }
  } catch (error) {
    console.error(`Error in ${actionName} action:`, error);
    alert(`Failed to complete ${actionName} action`);
  }
};

  // Example updated handler (apply same pattern to all handlers)
const handleCallClick = (e, property) => {
  // handleAction(e, property.id, "Call", async () => {
    // await navigator.clipboard.writeText(property.mobile_no);
    alert(`Copied: ${property.mobile_no}`);
  // }, "Call");
};

  const handleMessageClick = (e, property) => {
    // handleAction(e, property.id, "Call", async () => {
      navigate('/chat', { state: { property: property.id } });
    // }, "Call");
  };



  const handleLocationClick = (e, property) => {
    // handleAction(e, property.id, "Location", async () => {
      setLocationLoading(prev => ({ ...prev, [property.id]: true }));
      
      const openInMaps = (url) => {
        setLocationLoading(prev => ({ ...prev, [property.id]: false }));
        window.open(url, '_blank', 'noopener,noreferrer');
      };

      const fallbackUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(property.location)}`;
      
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const userLat = position.coords.latitude;
            const userLng = position.coords.longitude;
            const mapsUrl = property.lat && property.long
              ? `https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLng}&destination=${property.lat},${property.long}&travelmode=driving`
              : fallbackUrl;
            openInMaps(mapsUrl);
          },
          (error) => {
            console.error("Error getting location:", error);
            openInMaps(fallbackUrl);
          },
          { timeout: 10000 }
        );
      } else {
        openInMaps(fallbackUrl);
      }
    // }, "Location");
  };

 


 
   if (loading) {
    return (
      <Box sx={{ 
        backgroundColor: 'rgb(239, 231, 221)', 
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ backgroundColor: 'rgb(239, 231, 221)', minHeight: '110vh' }}>
      {/* Sticky Search Bar */}
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          px: 1,
          py: 1,
          backgroundColor: 'rgb(239, 231, 221)',
        }}
      >
        
 <CustomSearchBar 
            value={searchQuery} 
            onChange={(e) => setSearchQuery(e.target.value)}
            onPriceFilterChange={handlePriceFilterChange}
          />
      </Box>
      {/* Property Types */}
            <Box sx={{ px: 2 }}>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>Saved Buy Properties </Typography>
              <Box
                sx={{
                  display: 'flex',
                  gap: 1,
                  overflowX: 'auto',
                  whiteSpace: 'nowrap',
                  pb: 1,
                }}
              >
                {rentalTypes.map((type, index) => (
                  <Chip
                    key={index}
                    label={type}
                    variant="filled"
                    onClick={() => setSelectedType(prev => (prev == type ? null : type))}
                    sx={{
                      flexShrink: 0,
                      bgcolor: selectedType == type ? '#000000' : 'transparent',
                      color: selectedType == type ? '#ffffff' : '#000000',
                      border: '1px solid black',
                      fontWeight: 'bold',
                      '&:hover': {
                        bgcolor: selectedType == type ? '#000000' : 'rgba(0, 0, 0, 0.1)',
                      },
                    }}
                  />
                ))}
              </Box>
            </Box>

      {/* Saved Property Cards */}
      <Box sx={{ pb: 8 }}>
        {filteredProperties.length === 0 ? (
          <Box sx={{ px: 2, mt: 4, textAlign: 'center' }}>
            <Typography color="text.secondary">
              {selectedType 
                ? `No saved properties in "${selectedType}" category`
                : 'No saved properties match your search'}
            </Typography>
          </Box>
        ) : (
          filteredProperties.map((property) => {
            const images = property.images?.length > 0 ? property.images : ['/default-property-image.jpg'];
            const currentIndex = currentImageIndex[property.id] || 0;
            const showCarouselControls = images.length > 1;

            return (
            
              <Card
                key={property.id}
                sx={{
                  mb: 2,
                  mx: 2,
                  borderRadius: 3,
                  boxShadow: 2,
                  transition: 'transform 0.2s ease-in-out',
                  '&:hover': { transform: 'scale(1.015)', boxShadow: 4 },
                }}
                onClick={(e) => {
                  const isButtonClick = e.target.closest('button') || e.target.closest('svg');
                  if (!isButtonClick) {
                    navigate('/buy-description', { state: { propertyId: property.id, property: property.propertyData } });
                  }
                }}
              >
                <Box position="relative">
                  {/* Carousel Container */}
                  <Box sx={{ position: 'relative', width: '100%', height: '140px' }}>
                    <CardMedia
                      component="img"
                      image={images[currentIndex]}
                      alt="Property"
                      sx={{
                        width: '100%',
                        height: '140px',
                        objectFit: 'cover',
                        borderTopLeftRadius: 12,
                        borderTopRightRadius: 12,
                      }}
                    />
                    
                    {/* Carousel Navigation Arrows */}
                    {showCarouselControls && (
                      <>
                        <IconButton
                          sx={{
                            position: 'absolute',
                            top: '50%',
                            left: 8,
                            opacity: 0,
                            transform: 'translateY(-50%)',
                            backgroundColor: 'rgba(255,255,255,0.3)',
                            backdropFilter: 'blur(2px)',
                            '&:hover': { 
                              opacity: 1,
                              backgroundColor: 'rgba(255,255,255,0.5)' 
                            }
                          }}
                          onClick={(e) => handlePrevImage(property.id, e)}
                        >
                          <ChevronLeft fontSize="small" />
                        </IconButton>
                        <IconButton
                          sx={{
                            position: 'absolute',
                            top: '50%',
                            right: 8,
                            opacity: 0,
                            transform: 'translateY(-50%)',
                            backgroundColor: 'rgba(255,255,255,0.3)',
                            backdropFilter: 'blur(2px)',
                            '&:hover': { 
                              opacity: 1,
                              backgroundColor: 'rgba(255,255,255,0.5)' 
                            }
                          }}
                          onClick={(e) => handleNextImage(property.id, e)}
                        >
                          <ChevronRight fontSize="small" />
                        </IconButton>
                      </>
                    )}
                    
                    {/* Carousel Indicators */}
                    {showCarouselControls && (
                      <Box
                        sx={{
                          position: 'absolute',
                          bottom: 10,
                          left: '50%',
                          transform: 'translateX(-50%)',
                          display: 'flex',
                          gap: 1
                        }}
                      >
                        {images.map((_, index) => (
                          <Box
                            key={index}
                            onClick={(e) => {
                              e.stopPropagation();
                              setCurrentImageIndex(prev => ({
                                ...prev,
                                [property.id]: index
                              }));
                            }}
                            sx={{
                              width: 8,
                              height: 8,
                              borderRadius: '50%',
                              backgroundColor: currentIndex == index ? '#1976d2' : '#ccc',
                              cursor: 'pointer',
                              transition: 'background-color 0.3s'
                            }}
                          />
                        ))}
                      </Box>
                    )}
                  </Box>

                  <Box sx={{ position: 'absolute', top: 6, right: 6, display: 'flex', gap: 0.8 }}>
                    <Tooltip title="Remove from Wishlist">
                      <IconButton
                        sx={{ bgcolor: 'white', boxShadow: 1, p: 0.8 }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRemove(property.id);
                        }}
                      >
                        <Favorite color="error" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Share">
                      <IconButton
                        sx={{ bgcolor: 'white', boxShadow: 1, p: 0.8 }}
                        onClick={(e) => {
                          e.stopPropagation();
                          const shareText = `Check out this property: ${property.title}, located at ${property.location}`;
                          if (navigator.share) {
                            navigator.share({
                              title: property.title,
                              text: shareText,
                              url: window.location.href,
                            });
                          } else {
                            alert("Sharing is not supported on this browser.");
                          }
                        }}
                      >
                        <Share />
                      </IconButton>
                    </Tooltip>
                  </Box>
                  <Box sx={{ position: 'absolute', bottom: 6, right: 6 }}>
                    <Tooltip title="Like">
                      <IconButton
                        sx={{
                          bgcolor: 'white',
                          boxShadow: 1,
                          color: likedCards[property.id] ? 'blue' : 'default',
                          p: 0.8,
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleLike(property.id);
                        }}
                      >
                        {likedCards[property.id] ? <ThumbUpAlt /> : <ThumbUpAltOutlined />}
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Box>

                <CardContent sx={{ px: 2, py: 0.2, pb: '7px !important' }}>
                  {/* Rest of your card content remains the same */}
                  <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={0.5}>
                    <Typography 
                      variant="subtitle1" 
                      fontWeight="bold" 
                      noWrap 
                      sx={{ 
                        flex: 1,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        pr: 1 
                      }}
                    >
                      {property.title}-{property.property_name}
                    </Typography>
                    <Typography variant="body2" fontWeight="bold" color="primary" noWrap>
                      ₹{Number(String(property.price).replace(/[^0-9]/g, '')).toLocaleString('en-IN')}
                    </Typography>
                  </Box>
                  
                  <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                    <Typography 
                      variant="caption" 
                      color="text.secondary" 
                      noWrap
                      sx={{
                        flex: 1,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        pr: 1
                      }}
                    >
                      {property.location}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" noWrap>
                      {new Date(property.date).toLocaleDateString('en-IN', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric'
                      })}
                    </Typography>
                  </Box>

                  <Box display="flex" alignItems="center" mt={0.2}>
                    <Tooltip title="View directions in Google Maps">
                      <IconButton 
                        size="small" 
                        onClick={(e) => handleLocationClick(e, property)}
                        sx={{ p: 0, color: 'primary.main' }}
                      >
                        <LocationOn fontSize="small" />
                        <Typography variant="caption" color="text.primary" ml={0.5}>
                      Location 
                    </Typography>
                      </IconButton>
                    </Tooltip>
                    
                    <Tooltip title="Send Message">
                            <IconButton
                                         size="small"
                                         onClick={(e) => handleMessageClick(e, property)}
                                         sx={{ p: 0, color: 'primary.main', ml: 1 }}
                                       >
                                         <Chat fontSize="small" />
                                       </IconButton>
                          </Tooltip>
                    <Box sx={{ flexGrow: 1 }} />
                   <Button
                               size="small"
                               variant="outlined"
                               color="success"
                               startIcon={<Call fontSize="small" />}
                               sx={{ 
                                 textTransform: 'none', 
                                 px: 1, 
                                 py: 0.2, 
                                 fontSize: '0.7rem',
                                 minWidth: 'auto'
                               }}
                               onClick={(e) => handleCallClick(e, property)}
                             >
                               Call
                             </Button>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      border: '1px solid #e0e0e0',
                      borderRadius: 2,
                      overflow: 'hidden',
                    }}
                  >
                    {[
                      { label: 'Facing', value: property.facing },
                      { label: 'Area', value: `${property.area} ` },
                     // { label: 'Area', value: `${property.area} (${property.length} × ${property.width})` },
                      { label: 'Posted By', value: property.posted_by },
                    ].map((item, index) => (
                      <Box
                        key={index}
                        sx={{
                          flex: 1,
                          px: 1,
                          py: 0.2,
                          textAlign: 'center',
                          borderRight: index < 2 ? '1px solid #e0e0e0' : 'none',
                        }}
                      >
                        <Typography variant="caption" color="text.secondary" noWrap>
                          {item.label}
                        </Typography>
                        <Typography variant="body2" fontWeight="bold" noWrap>
                          {item.value}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </CardContent>
              </Card>
                );
          })
        )}
      </Box>
{/* Subscription Modal */}
      {showSubscribeModal && (
        <Box sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          zIndex: 9999,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <Paper sx={{ padding: 3, maxWidth: 300, textAlign: 'center' }}>
            <Typography variant="h6" gutterBottom>
              Subscription Required
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Please subscribe to use the {featureRequested} feature.
            </Typography>
            <Button 
              variant="contained" 
              color="primary"
              onClick={() => {
          setShowSubscribeModal(false);
          navigate('/user-subscription');
        }}
            >
              OK
            </Button>
          </Paper>
        </Box>
      )}

      
      {/* Limit Exceeded Modal */}
{showLimitModal && (
  <Box sx={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 9999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }}>
    <Paper sx={{ padding: 3, maxWidth: 300, textAlign: 'center' }}>
      <Typography variant="h6" gutterBottom>
        Limit Exceeded
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        {userPlan?.no_of_properties_unlimited 
          ? "You have unlimited access to properties."
          : `You've reached your limit of ${userPlan?.no_of_properties || 10} properties. 
             Please upgrade your subscription plan for more.`
        }
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
             <Button 
               variant="outlined" 
               color="primary"
               onClick={() => setShowLimitModal(false)}
             >
               Cancel
             </Button>
             <Button 
               variant="contained" 
               color="primary"
               onClick={() => setShowLimitModal(false)}
             >
               OK
             </Button>
           </Box>
    </Paper>
  </Box>
)}
      <BottomNavbar />
    </Box>
  );
};
export default BuySaves;